export default __webpack_public_path__ + "static/fans-mobile-a1023c55c64e4319390e544835d2a715.png";